(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["back-top~button~drawer~dropdown~flag~index~input~pagination~space~table~tabs~tag~transfer"],{

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isValid = function isValid(value) {
  return value !== undefined && value !== null && value !== '';
};

/* harmony default export */ __webpack_exports__["a"] = (isValid);

/***/ })

}]);